import React from "react";
import { Section } from "./Sections";
import { Card } from "./Cards";

function OvinDetails() {
  return (
    <div>
      {/* Title */}
      <h2 className="text-3xl md:text-4xl font-bold text-center bg-black text-white py-4 rounded-lg mb-20">
        Soin, santé et bien-être des ovins
      </h2>
      {/* Présentation */}
      <Section title="Présentation générale">
        <ul className="grid md:grid-cols-2 gap-4 list-disc list-inside">
          <li>Famille : Ovins</li>
          <li>Groupe : Troupeau</li>
          <li>Cri : Bêle</li>
          <li>Abri : Bergerie</li>
          <li>Gestation : 152 jours</li>
          <li>Espérance de vie : 10–12 ans</li>
          <li>Ordre : Artiodactyla</li>
          <li>Classe : Mammalia</li>
          <li>
            Poids adulte :
            <ul className="ml-6 list-disc">
              <li>Mâle : 45–160 kg</li>
              <li>Femelle : 45–100 kg</li>
            </ul>
          </li>
        </ul>
      </Section>

      {/* Alimentation */}
      <Section title="Alimentation">
        <p>
          Les ovins sont des ruminants, comme les bovins. Leur digestion repose
          sur le pâturage prolongé et l’apport de fourrages adaptés.
        </p>

        <Card title="Fourrages recommandés">
          <ul className="list-disc list-inside space-y-1">
            <li>Fanes d’arachides</li>
            <li>Feuilles de manioc</li>
            <li>Paille de riz</li>
          </ul>
        </Card>

        <Card title="Complément alimentaire (recette)">
          <ul className="list-disc list-inside space-y-1">
            <li>850 g de farineux (maïs, manioc, son de riz)</li>
            <li>150 g de tourteau</li>
            <li>2,5 g de poudre d’os</li>
            <li>3 g de sel</li>
          </ul>
          <p className="mt-4 font-medium">Ration quotidienne :</p>
          <ul className="list-disc list-inside">
            <li>250 g / mouton adulte</li>
            <li>500 g / brebis gestante</li>
            <li>500–1000 g / brebis allaitante</li>
          </ul>
        </Card>
      </Section>

      {/* Abreuvement */}
      <Section title="Abreuvement">
        <p>Les moutons doivent toujours avoir accès à une eau propre.</p>

        <div className="overflow-x-auto">
          <table className="w-full border border-gray-200 text-left">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 border">Type</th>
                <th className="p-3 border">Besoin quotidien</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 border">Agneau</td>
                <td className="p-3 border">0,5 L</td>
              </tr>
              <tr>
                <td className="p-3 border">Jeune</td>
                <td className="p-3 border">1,5 L</td>
              </tr>
              <tr>
                <td className="p-3 border">Adulte</td>
                <td className="p-3 border">2,5 L</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Section>

      {/* Reproduction */}
      <Section title="Reproduction">
        <ul className="list-disc list-inside space-y-2">
          <li>Premières chaleurs : 6 mois</li>
          <li>Âge conseillé pour la reproduction : 8 mois</li>
          <li>Cycle : 21 jours</li>
          <li>Durée des chaleurs : 1 à 2 jours</li>
          <li>Gestation : 5 mois</li>
          <li>1 bélier pour 30 femelles</li>
          <li>Sevrage des agneaux : à partir de 4 mois</li>
        </ul>
      </Section>

      {/* Santé */}
      <Section title="Santé et bien-être">
        <p>
          Les moutons sont sensibles aux parasites internes et aux maladies. Une
          vermifugation régulière et une vaccination annuelle sont essentielles.
        </p>

        <Card title="Signes d’alerte">
          <ul className="list-disc list-inside space-y-1">
            <li>Diarrhée</li>
            <li>Isolement du troupeau</li>
            <li>Manque d’appétit ou d’eau</li>
            <li>Écoulement des yeux ou du nez</li>
          </ul>
        </Card>

        <p>
          La température rectale normale se situe entre{" "}
          <strong>38,3°C et 39,9°C</strong>. En cas de doute, contactez
          immédiatement votre vétérinaire.
        </p>
      </Section>

      {/* Logement */}
      <Section title="Logement">
        <Card title="Surface recommandée">
          <ul className="list-disc list-inside space-y-1">
            <li>Adulte : 0,20 – 0,40 m²</li>
            <li>Brebis avec agneau : 0,30 – 0,50 m²</li>
            <li>Jeune : 0,15 – 0,20 m²</li>
            <li>Bélier : 0,50 – 0,75 m²</li>
          </ul>
        </Card>
      </Section>
    </div>
  );
}



export default OvinDetails;
